import React, { useEffect, useState } from "react";
import { Table, Pagination, Spinner, Button } from "react-bootstrap";
import NavbarComponent from "../layout/NavbarComponent";
import Footer from "../layout/Footer";
import axios from "axios";
import { Layout } from "../layout/Layout";
import PaginationComponent from "./PaginationComponent";

const API_URL = process.env.REACT_APP_API_URL;

const PremiumRequest = () => {
    const [requestPremium, setRequestPremium] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    // Fetch pending requests
    const fetchPendingRequests = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${API_URL}/requests/pending?page=${page}&size=${size}`
            );
            const data = response.data;
            if (data.success) {
                setRequestPremium(data.data);
                setTotalPages(data.totalPages);
            } else {
                alert("Error fetching requests: " + data.message);
            }
        } catch (error) {
            alert("Error: " + error.message);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchPendingRequests();
    }, [page, size]);

    // Update Premium
    const savePremiumToServer = async (pet, days) => {
        try {
            const response = await axios.put(
                `${API_URL}/updatePremium/${pet.petId}`,
                {
                    isPremium: true,
                    validDays: Number(days),
                }
            );
            let isUpdated = true;
            await axios.put(
                `${API_URL}/update/request/${pet.petId}/${isUpdated}`
            );
            const updatedPet = response.data;

            // Update table row
            setRequestPremium((prev) =>
                prev.map((req) =>
                    req.pet.petId === pet.petId
                        ? { ...req, pet: updatedPet, isUpdated: true }
                        : req
                )
            );

            alert("Premium updated successfully!");
        } catch (error) {
            console.error("Error:", error);
            alert("Failed to update premium.");
        }
    };

    return (
       <Layout>
    <div className="premium-page">

        {loading ? (
            <div className="premium-loading">
                <Spinner animation="border" style={{ color: "#e07b39" }} />
            </div>
        ) : (
            <div className="premium-container">

                {/* Heading */}
                <div className="premium-heading-row">
                    <div>
                        <h2 className="premium-title">Pending Premium Requests</h2>
                        <p className="premium-subtitle">
                            {requestPremium.length} {requestPremium.length === 1 ? "request" : "requests"} to review
                        </p>
                    </div>
                </div>

                {requestPremium.length === 0 ? (
                    <div className="premium-empty">
                        <div className="premium-empty-badge">0</div>
                        <p className="premium-empty-text">No pending requests</p>
                        <p className="premium-empty-sub">New premium requests will show up here.</p>
                    </div>
                ) : (
                    <>
                        {/* Table Card */}
                        <div className="premium-card">
                            <div className="table-responsive">
                                <Table className="premium-table mb-0 align-middle">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Pet Name</th>
                                            <th>Owner Name</th>
                                            <th className="d-none d-md-table-cell">Owner Email</th>
                                            <th>Days</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {requestPremium.map((req) => (
                                            <tr key={req.id}>
                                                <td className="premium-id">{req.id}</td>
                                                <td className="fw-semibold">{req.pet.petName}</td>
                                                <td>{req.pet.owner.userName}</td>
                                                <td className="d-none d-md-table-cell text-break text-muted">
                                                    {req.pet.owner.userEmail}
                                                </td>
                                                <td>{req.days}</td>

                                                {/* Status Pill */}
                                                <td>
                                                    {req.isUpdated ? (
                                                        <span className="premium-pill premium-pill--success">
                                                            Updated
                                                        </span>
                                                    ) : (
                                                        <span className="premium-pill premium-pill--pending">
                                                            Pending
                                                        </span>
                                                    )}
                                                </td>

                                                <td>
                                                    {!req.isUpdated && (
                                                        <button
                                                            className="premium-btn premium-btn--solid"
                                                            onClick={() =>
                                                                savePremiumToServer(req.pet, req.days)
                                                            }
                                                        >
                                                            Update Premium
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        {/* Pagination Section */}
                        <div className="premium-pagination">
                            <PaginationComponent
                                page={page}
                                setPage={setPage}
                                size={size}
                                setSize={setSize}
                                totalPages={totalPages}
                            />
                        </div>
                    </>
                )}
            </div>
        )}

    </div>

    <style>{`
        .premium-page {
            min-height: 100vh;
            background: #F7F8F6;
            display: flex;
            flex-direction: column;
            font-family: 'Inter', sans-serif;
        }

        .premium-loading {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
        }

        .premium-container {
            max-width: 1180px;
            width: 100%;
            margin: 0 auto;
            padding: 32px 24px;
            flex: 1;
        }

        .premium-heading-row {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 22px;
        }

        .premium-title {
            font-weight: 700;
            font-size: 24px;
            color: #1C2420;
            margin: 0;
        }

        .premium-subtitle {
            font-size: 13.5px;
            color: #8B978F;
            margin: 4px 0 0;
        }

        .premium-empty {
            text-align: center;
            padding: 72px 20px;
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
        }

        .premium-empty-badge {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background: rgba(224, 123, 57, 0.1);
            color: #e07b39;
            font-weight: 700;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 16px;
        }

        .premium-empty-text {
            font-weight: 600;
            font-size: 17px;
            color: #1C2420;
            margin: 0 0 4px;
        }

        .premium-empty-sub {
            font-size: 13.5px;
            color: #8B978F;
            margin: 0;
        }

        .premium-card {
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
            box-shadow: 0 1px 2px rgba(16, 24, 20, 0.03);
            overflow: hidden;
        }

        .premium-table thead {
            background: rgba(224, 123, 57, 0.06);
        }

        .premium-table thead th {
            font-size: 11.5px;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            font-weight: 700;
            color: #B8632C;
            padding: 14px 16px;
            border-bottom: 1px solid #F0E4D8;
            white-space: nowrap;
        }

        .premium-table tbody td {
            padding: 14px 16px;
            font-size: 14px;
            color: #333B36;
            border-bottom: 1px solid #F2F3F0;
            vertical-align: middle;
        }

        .premium-table tbody tr:last-child td {
            border-bottom: none;
        }

        .premium-table tbody tr:hover {
            background: #FBFAF8;
        }

        .premium-id {
            font-weight: 600;
            color: #5C6862;
        }

        .premium-pill {
            display: inline-block;
            padding: 4px 11px;
            border-radius: 999px;
            font-size: 12px;
            font-weight: 600;
        }

        .premium-pill--success { background: rgba(47, 158, 106, 0.12); color: #21875A; }
        .premium-pill--pending { background: rgba(224, 123, 57, 0.14); color: #B8632C; }

        .premium-btn {
            font-size: 13px;
            font-weight: 600;
            padding: 7px 14px;
            border-radius: 8px;
            border: 1.5px solid transparent;
            cursor: pointer;
            transition: all 0.15s ease;
            white-space: nowrap;
        }

        .premium-btn--solid {
            background: #e07b39;
            color: #fff;
        }
        .premium-btn--solid:hover { background: #c96a2d; }

        .premium-pagination {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
        }
    `}</style>
</Layout>

    );
};

export default PremiumRequest;
